const format = {
  time: "hh:mm A",
  time_withsec: "hh:mm:ss A",
  date: "DD/MM/YYYY",
  date_time: "DD/MM/YYYY hh:mm A",
  date_time_withsec: "DD/MM/YYYY hh:mm:ss A",
};

export default format;
